import Cookies from "js-cookie"
import React from "react"
import Modal from "react-modal"

export default function OnlineModal() {
    return (
        <>
            <LandingModal />
        </>
    )
}

export function LandingModal() {
    const cookieName = "landing-modal-dialog"
    const cookie = Cookies.get(cookieName)
    const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(!cookie)
    const [modalIsAgreed, setModalIsAgreed] = React.useState<boolean>(false)
    Modal.setAppElement("#app")

    function closeModal() {
        if (modalIsAgreed) {
            setModalIsOpen(false)
            const now = new Date()
            now.setTime(now.setUTCHours(23, 59, 59, 0))
            Cookies.set(cookieName, "true", { expires: now })
        }
    }

    function handleSelectAgreed() {
        console.log("Agreed before ", modalIsAgreed)
        setModalIsAgreed(!modalIsAgreed)
    }

    const customStyles = {
        overlay: {
            backgroundColor: "rgba(0,0,0, 0.5)",
            zIndex: 1040,
        },
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            className="fade top show "
            ariaHideApp={true}
            data-backdrop="static"
            data-keyboard="false"
            id="landing-modal"
            style={customStyles}
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content" id="modalContent">
                    <div className="modal-header" id="modalHeader">
                        <h5 className={"modal-title"} id="landing-modal-header">
                            Datenschutzerklärung
                        </h5>
                    </div>
                    <div className="modal-body" id="modalBody">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="landing-modal-confirm" onClick={handleSelectAgreed} />
                            <label className="form-check-label" htmlFor="landing-modal-confirm">
                                Ich nehme zur Kenntnis, dass es sich bei dieser online-Version des XR-Viewers um eine Demo-Version handelt, die reinen Test-
                                Zwecken dient. Eine Verarbeitung von E-Rechnungen mit validen Rechnungsdaten ist ausdrücklich nicht vorgesehen. Ich bestätige
                                hiermit, dass ich ausschließlich Test-Rechnungen hochladen werde, die keinerlei Rückschlüsse auf tatsächlich ausgestellte oder
                                geplante Rechnungen zulassen.
                            </label>
                        </div>
                    </div>
                    <div className="modal-footer" id="modalFooter">
                        <button
                            id="landing-modal-close"
                            type="button"
                            className="btn btn-primary btn-primary-disabled"
                            disabled={!modalIsAgreed}
                            data-dismiss="modal"
                            onClick={closeModal}
                        >
                            Schliessen
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
